import { core } from '@mgmresorts/vega-tokens';
import { useState, useLayoutEffect, useEffect } from 'react';

export function useMobile() {
  const isMobileViewport = useMediaQuery(`(max-width: ${core.BreakpointLg}px)`);
  return isMobileViewport !== false;
}

export function useMediaQuery(mediaQuery: string) {
  const [isMatch, setIsMatch] = useState<boolean | undefined>(undefined);

  const useTheEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect;

  useTheEffect(() => {
    const list = window.matchMedia(mediaQuery);
    setIsMatch(list.matches);

    const handleChangeEvent = (e: MediaQueryListEvent) => {
      setIsMatch(e.matches);
    };

    list.addEventListener('change', handleChangeEvent);

    return () => {
      list.removeEventListener('change', handleChangeEvent);
    };
  }, [mediaQuery]);

  return isMatch;
}

export default useMediaQuery;
